angular.module("ainapp")
    .controller("timesheetReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Time Sheet Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Init = function () {


                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    VoucherNo: "",
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                    VoucherNo: "",
                }

                $scope.load = false;
                $scope.isFilter = false;


                $scope.Columns = [
                    {
                        field: "TimeSheet.VoucherNumber",
                        title: "Ref No #",
                        width: "120px",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },

                    {
                        field: "TimeSheet.Month",
                        title: "Month",
                        width: "100px",
                       },
                    {
                        field: "TimeSheet.Year",
                        title: "Year",
                        width: "100px",
                       },
                    {
                        field: "StartTime",
                        title: "Start Time",
                        template: "#= kendo.toString(kendo.parseDate(StartTime, 'yyyy-MM-dd'), 'dd/MM/yyyy  H:mm') #",
                        width: "130px",
                       },
                    {
                        field: "EndTime",
                        title: "End Time",
                        template: "#= kendo.toString(kendo.parseDate(EndTime, 'yyyy-MM-dd'), 'dd/MM/yyyy  H:mm') #",
                        width: "130px",
                       },
                    {
                        field: "TotalHours",
                        title: "Total Hours",
                        width: "100px",
                       },

                    {
                        field: "NormalHours",
                        title: "Normal Hours",
                        width: "100px",
                       },
                    {
                        field: "OverTimeHours",
                        title: "Over Time Hours",
                        width: "100px",
                       },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        width: "150px",
                       },

                    // {
                    //     title: "Cost Centers",
                    //     width: "160px",
                    //     template: "<p ng-repeat='cc in dataItem.TimeSheetCosts'>{{cc.CostCenterName}}</p>",
                    //     },

                ];


                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Time Sheet").then(function (response) {
                    $scope.CostCenters = response.data;
                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            //  template: "<a ng-repeat='cc in dataItem.SalesInvoiceCosts' ng-click='temp(dataItem, $event)' >{{cc.CostCenterName}}  </a>",
                            width: '100px',
                            //ng-if='cc.ParentId == $scope.CostCenters[i].CostCenterId'
                        }
                        $scope.Columns.push(clm);

                        $scope.loadKendo1();
                    })

                });


            }
            $scope.Init();



            $scope.loadKendo1 = function () {

                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            if ($scope.isFilter) {


                                o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                                o.data.FromDay = $scope.filter.FromDate.getDate();
                                o.data.FromYear = $scope.filter.FromDate.getFullYear();

                                o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                                o.data.ToDay = $scope.filter.ToDate.getDate();
                                o.data.ToYear = $scope.filter.ToDate.getFullYear();

                                o.data.VoucherNo = $scope.filter.VoucherNo;
                                o.data.CostCenters = $scope.CostCenters;
                                o.data.BranchId = $scope.filter.BranchId;



                                MainService.TimeSheetReport(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }

                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.TimeSheetCosts, function (a) {

                                        var afield = a.CostCenter.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.CostCenter.Name;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                "TimeSheet.VoucherNumber": {
                                    type: "string",
                                    editable: false,
                                },
                                "Date": {
                                    type: "date",
                                    editable: false,
                                },
                                "TimeSheet.Month": {
                                    type: "string",
                                    editable: false,
                                },
                                "TimeSheet.Year": {
                                    type: "number",
                                    editable: false,
                                },
                                "StartTime": {
                                    type: "date",
                                    editable: false,
                                },
                                "EndTime": {
                                    type: "date",
                                    editable: false,
                                },
                                "TotalHours": {
                                    type: "number",
                                    editable: false,
                                },

                                "NormalHours": {
                                    type: "number",
                                    editable: false,
                                },
                                "OverTimeHours": {
                                    type: "number",
                                    editable: false,
                                },
                                "Remarks": {
                                    type: "string",
                                    editable: false,
                                },
                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                });

                $scope.KendoGridOptions = {


                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },

                    columns: $scope.Columns,
                };

            }


            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                $scope.filter.CostCenters = $scope.CostCenters;

                MainService.PrintTimeSheetReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
